import { render, staticRenderFns } from "./makelaarskosten.vue?vue&type=template&id=0a921838"
import script from "./makelaarskosten.vue?vue&type=script&lang=js"
export * from "./makelaarskosten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports